// client/src/components/RegistrationBanner/RegistrationBanner.js

import React from 'react';
import './RegistrationBanner.css';

const RegistrationBanner = () => {
  return (
    <section className="reg-banner-section">
      <div className="reg-banner-content">
        <h2>Join Om Nidhi Productions</h2>
        <p>Looking for opportunities? Register with us officially.</p>

        <a 
          href="/register" 
          className="reg-banner-button"
        >
          Go to Registration
        </a>
      </div>
    </section>
  );
};

export default RegistrationBanner;